import { isAutorizedUser } from 'common/utils/userTypes';

import { useUserType } from 'store/features/auth/selectors';

const useIsAutorizedUser = (): boolean => {
  const userType = useUserType();
  return isAutorizedUser(userType);
};

export default useIsAutorizedUser;
